<template>
  <div class="nav">
    <div class="inner">
      <router-link :to="{name: 'Home'}">
        <img alt="九恒" src="../../../assets/logo.jpg">
      </router-link>
      <ul>
        <li :class="{'c' : $route.name === 'About' || $route.name === 'AboutTab', 'h': overNav === 0}" @mouseenter="showSub(0)" @mouseleave="hideSub(0)">
          <router-link :to="{name: 'About'}">关于九恒</router-link>
          <ul>
            <li>
              <a href="#/About/1">社会责任</a>
            </li>
            <li>
              <a href="#/About/2">国际化</a>
            </li>
            <li>
              <a href="#/About/3">企业资质</a>
            </li>
            <!-- <li>
              <a href="#/About/4">合作伙伴</a>
            </li> -->
          </ul>
        </li>
        <li :class="{'c' : $route.name.indexOf('Busi') >= 0, 'h': overNav === 1}" @mouseenter="showSub(1)" @mouseleave="hideSub(1)">
          <router-link :to="{name: 'Busi'}">业务板块</router-link>
          <ul>
            <li><router-link :to="{name: 'Busi1'}">智电设计</router-link></li>
            <li><router-link :to="{name: 'Busi2'}">智能配网</router-link></li>
            <li><router-link :to="{name: 'Busi3'}">智慧运营</router-link></li>
            <li><router-link :to="{name: 'Busi5'}">绿电低碳</router-link></li>
            <li><router-link :to="{name: 'Busi4'}">智能产品</router-link></li>
          </ul>
        </li>
        <li :class="{'c' : $route.name === 'Case', 'h': overNav === 2}"><router-link :to="{name: 'Case'}">行业案例</router-link></li>
        <li :class="{'c' : $route.name === 'Join', 'h': overNav === 3}"><router-link :to="{name: 'Join'}">加入九恒</router-link></li>
        <li :class="{'c' : $route.name === 'Contact', 'h': overNav === 4}"><router-link :to="{name: 'Contact'}">联系我们</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topNav',
  data() {
    return {
      overNav: -1,
      counter: 0
    }
  },
  methods: {
    showSub(n) {
      this.overNav = n
      window.clearTimeout(this.counter)
    },
    hideSub() {
      this.counter = setTimeout(() => {
        this.overNav = -1
      }, 400)
    }
  }
}
</script>
